import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AccesoRequest } from 'src/app/modal/niubiz/acceso-request';
import { AccesoResponse } from 'src/app/modal/niubiz/acceso-response';
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import {PrepagoConceptoRequest} from 'src/app/modal/niubiz/prepago-concepto-request';
import { PagoConceptoRequest } from 'src/app/modal/niubiz/pago-concepto-request';
@Injectable({
  providedIn: 'root'
})
export class NiubizService {

  constructor(private httpClient:HttpClient) { }

  obtenerAcceso(accesoRequest:AccesoRequest){
    let url = `${environment.urlAcceso}`;
    //console.log("url",url);
    return this.httpClient.post<AccesoResponse>(url,accesoRequest).pipe(
      map(data => {   
        let response: AccesoResponse;
        response = data;
        return response;
      },
      error =>{      
        return new Response("9999", error);
      })) 
  }

 
  private basePath = environment.urlBase;
  //private headers = new HttpHeaders();
  private headersSeguridad = new HttpHeaders();



  

  registrarPrePagoConceptoPago(prepagoConceptoRequest:PrepagoConceptoRequest   
  ): Observable<any> {
    // this.headersSeguridad = new HttpHeaders()
    //   .set("Content-Type", "application/json")
    //   .set(
    //     "Authorization",
    //     "Bearer " + this.storageService.getCurrentSession().token
    //   );
    const urlEndpoint =
      this.basePath + "api/pago-concepto/registrar-prepago-concepto-electronico";
    
    return this.httpClient
     // .post<any>(urlEndpoint, data, { headers: this.headersSeguridad })
     .post<any>(urlEndpoint, prepagoConceptoRequest)
      .pipe(map((res) => res));
  }
  
  
    registrarPagoConceptoPago(
      pagoConceptoRequest:PagoConceptoRequest
  ): Observable<any> {
    // this.headersSeguridad = new HttpHeaders()
    //   .set("Content-Type", "application/json")
    //   .set(
    //     "Authorization",
    //     "Bearer " + this.storageService.getCurrentSession().token
    //   );
    const urlEndpoint = this.basePath + "api/pago-concepto/registrar-pago-concepto-electronico";
    
    return this.httpClient
      .post<any>(urlEndpoint, pagoConceptoRequest)
      .pipe(map((res) => res));
  }
  
}
